/**
 * FAQ question matching for the app. FAQ is extracted on the server only
 * (functions/src/Scapper/FaqExtractor.ts) and arrives with GetScrapped.
 */

const FAQ_SECTION_TITLES = new Set([
    'casto kladene otazky',
    'casto kladene dotazy',
    'nejcastejsi otazky',
    'nejcastejsi dotazy',
    'nejcastejsie otazky',
    'frequently asked questions',
    'faq',
    'faqs',
    'otazky a odpovedi',
    'questions and answers',
    'q a',
    'q a a',
]);

export function normalizeFaqText(value: string | null | undefined): string {
    return decodeFaqEntities(String(value || ''))
        .replace(/<[^>]+>/g, ' ')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

export function isFaqSectionTitle(value: string | null | undefined): boolean {
    const normalized = normalizeFaqText(value);
    return !!normalized && FAQ_SECTION_TITLES.has(normalized);
}

function decodeFaqEntities(value: string): string {
    return value
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#39;|&apos;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
        .replace(/&#x([0-9a-f]+);/gi, (_, code) => String.fromCharCode(parseInt(code, 16)));
}
